import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';

import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');


class LikePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {likes: [], likeArr: []}
        this.getLikes = this.getLikes.bind(this);
    }

    componentDidMount() {
        this.getLikes();
    }

    getLikes() {
        var url = '/code/api_feeds.php?api=getLikeFeeds&id_feed=' + this.props.feed.id_feed + '&feed_type=' + this.props.feed.feed_type;

        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {


                    this.setState({likes: response.data.data}, () => {
                        this.generateLikes()
                    });

                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
    }

    generateLikes() {
        var likeArr = [];

        for (var like of this.state.likes) {
            //console.log(school);
            likeArr.push(
                <Link key={"like-popup-" + like.id_like} to={like.avata_link}>
                    <div className="user_row">
                        <div className="user_row_left">
                            <img className="img_circle" src={like.avata}/>
                        </div>
                        <div className="user_row_right">
                            <div className="user_name">{like.full_name}</div>
                            <div className="u_text">{like.sub_name}</div>
                        </div>
                    </div>
                </Link>
            );

        }

        this.setState({likeArr: likeArr});
    }

    componentWillReceiveProps(nextProps) {

    }

    handleBack(e) {
        this.props.onClose();
    }


    render() {

        return (
            <div className="likepopup_wrapper">

                <div className="title">Likes <a onClick={this.handleBack.bind(this)} className="btn_remove"><img
                    src="static/img/appimg/icon_close_x.png"/></a></div>
                <div className="content">
                    {this.state.likeArr}

                </div>

            </div>

        )
    }
}

export default LikePopup;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/LikePopup.js
 **/